import cronstrue from 'cronstrue';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Loader, TasksStore, Tooltip } from 'Mri.Web.Common';
import * as React from 'react';
import { BsChevronDoubleUp } from '@react-icons/all-files/bs/BsChevronDoubleUp';
import { BsFiles } from '@react-icons/all-files/bs/BsFiles';
import { BsPencilSquare } from '@react-icons/all-files/bs/BsPencilSquare';
import { BsToggleOff } from '@react-icons/all-files/bs/BsToggleOff';
import { BsToggleOn } from '@react-icons/all-files/bs/BsToggleOn';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, ButtonGroup } from 'reactstrap';
import { AppStore } from '../Core/AppStore';
//import { FileSystemsStore } from './FileSystemsStore';
import { CloudConfigsStore } from './CloudConfigsStore';

export interface ICloudConfigItemProps {
    readonly config: Mri.CloudConfigs.CloudConfig;
}

@autoinject
@observer
export class CloudConfigItem extends React.Component<ICloudConfigItemProps> {
    public render() {
        const config = this.props.config;

        return (
            <tr className={!config.active ? 'inactive-row' : ''}>
                <td className="align-middle">{config.name}</td>
                <td className="align-middle">
                    <LinkContainer to={`/cloud-configs/configs/${this.props.config.cloudConfigGuid}/status`}>
                        <Button color="link">
                            {this.status?.updated ?? '-'}/{this.status?.total ?? '-'}
                        </Button>
                    </LinkContainer>
                    {this.updating && (
                        <Tooltip message="Updates in progress">
                            <BsChevronDoubleUp className=" text-running text-pulse ps-2" />
                        </Tooltip>
                    )}
                </td>
                <td className="align-middle">
                    <i>{config.schedule ? cronstrue.toString(config.schedule) : ''}</i>
                </td>
                <td className="align-middle">{config.configJson}</td>
                <td className="align-middle">
                    <ButtonGroup className="py-1">
                        <Tooltip message="Edit Config" delay={0}>
                            <LinkContainer to={`/cloud-configs/configs/${this.props.config.cloudConfigGuid}/edit`}>
                                <Button color="primary">
                                    <BsPencilSquare />
                                </Button>
                            </LinkContainer>
                        </Tooltip>

                        <Tooltip message="Copy Config To New" delay={0}>
                            <LinkContainer
                                to={{
                                    pathname: `/cloud-configs/configs/create`,
                                    state: { copy: this.props.config.cloudConfigGuid },
                                }}
                            >
                                <Button color="primary">
                                    <BsFiles />
                                </Button>
                            </LinkContainer>
                        </Tooltip>

                        {this.props.config.active && (
                            <Tooltip message="Deactivate" delay={0}>
                                <Button color="success" onClick={this.deactivate}>
                                    <BsToggleOn />
                                </Button>
                            </Tooltip>
                        )}
                        {!this.props.config.active && (
                            <Tooltip message="Activate" delay={0}>
                                <Button color="secondary" onClick={this.activate}>
                                    <BsToggleOff />
                                </Button>
                            </Tooltip>
                        )}
                    </ButtonGroup>
                </td>
            </tr>
        );
    }

    @computed
    private get status() {
        return this.cloudConfigsStore.configStatuses.get(this.props.config.cloudConfigGuid);
    }

    @computed
    private get updating() {
        return !!this.status && this.status.updating > 0;
    }

    @bind
    private async deactivate(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        try {
            this.cloudConfigsStore.deactivateAsync(this.props.config.cloudConfigGuid);
        } catch (e: any) {
            console.error(e);
            this.appStore.alertHandle.setError(e);
        }
    }

    @bind
    private async activate(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        try {
            this.cloudConfigsStore.activateAsync(this.props.config.cloudConfigGuid);
        } catch (e: any) {
            console.error(e);
            this.appStore.alertHandle.setError(e);
        }
    }

    @inject
    private readonly cloudConfigsStore!: CloudConfigsStore;
    @inject
    private readonly appStore!: AppStore;
    @inject
    private readonly tasksStore!: TasksStore;
}
